/* Dansk katalog for locale-closing-cash-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'clo.cash.quickComments': 'Hurtigkommentarer',
  'clo.cash.quickCountLabel': 'Optalt af den daglige leder',
  'clo.cash.quickCountText': 'Kassebeholdningen er fysisk optalt pr. 31.12.{{year}} af den daglige leder.',
  'clo.cash.quickSheetLabel': 'Optællingsskema gemt',
  'clo.cash.quickSheetText': 'Det underskrevne optællingsskema er kontrolleret og gemt i bilagsmappen.',
  'clo.cash.quickReportLabel': 'Kontrolleret mod kasserapport',
  'clo.cash.quickReportText': 'Optællingen er kontrolleret mod kasserapporten pr. 31.12.{{year}}.',
  'clo.cash.openPosting': 'Opret fri postering',
  'clo.cash.postingTitle': 'Korrigér kassebeholdning',
  'clo.cash.postingDescription': 'Korrektion efter kasseoptælling {{year}}',
  'clo.cash.postingLoadError': 'Kunne ikke indlæse fri postering.',
  'clo.cash.postingSaved': 'Posteringen er bogført. Kontrollér differencen igen.',
});
